//import 'ol/ol.css';
import { INode, FeatureType, ICAMSKey, IAPIResult, TextPack } from '../Shared/Models/UtilityModels';
import { WKT } from 'ol/format';
import { Feature } from 'ol';
import GeometryType from 'ol/geom/GeometryType';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import { OptionalTracingLayer } from '../Shared/Map/MainMap';
import { ModalPrompts, PredefinedModalEnum } from '../Shared/Utility/ModalPrompts';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_promptModals = '#placeholder-for-promptModals',
    placeholder_for_legalmodals = '#placeholder-for-legalmodals',
    placeholder_for_legalmodals2 = '#placeholder-for-legalmodals2',

    troEditModal = '#troEditModal',
    troEditHighlightTable = '#troEditHighlightTable',
    troEditHighlightsAddBtn = '#troEditHighlightsAddBtn',
    troEditHighlightsEditBtn = '#troEditHighlightsEditBtn',
    troEditHighlightsDeleteBtn = '#troEditHighlightsDeleteBtn',

    tro_GeomEditModal = '#tro_GeomEditModal',
    tro_GeomEditCloseBtn = '#tro_GeomEditCloseBtn',
    tro_GeomEditShowTROBtn ='#tro_GeomEditShowTROBtn',
    tro_GeomEditForm = '#tro_GeomEditForm',
    tro_GeomEditCancelBtn = '#tro_GeomEditCancelBtn',
    tro_GeomEditDeleteBtn = '#tro_GeomEditDeleteBtn',
    tro_GeomEditSubmitBtn = '#tro_GeomEditSubmitBtn',

    newTROWizardPanel = '#newTROWizardPanel',
    newTROWizardCloseBtn = '#newTROWizardCloseBtn',
    newTROWizard_CancelBtn = '#newTROWizard_CancelBtn',
    newTROWizard_SaveBtn = '#newTROWizard_SaveBtn'
}

export class TRO_Highlights {

    // ----------------------------------------------------------- //
    // GLOBAL VAR
    private newTROWizardState: { troCode?: string, drawFeature?: Feature, reOpenTROEditModal?: Boolean } = {};
    private subscriptionDrawCompleted;

    // List of buttions in the action toolbar
    private highlightsActionBtns = {
        add: { btn: null, enable: false },
        edit: { btn: null, enable: false },
        delete: { btn: null, enable: false }
    };

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        const self = this;
        // Wizard btns
        Utilities.GetControl(jqc.newTROWizard_SaveBtn).on("click", function () { self.newTROWizard_Save(); });
        Utilities.GetControl(jqc.newTROWizard_CancelBtn).on("click", function () {
            self.newTROWizard_Cancel();
            var data: ICAMSKey = { code: self.newTROWizardState.troCode, featureType: FeatureType.TRO };
            events.bus.publish(events.eventOpenTROEditPanel(data));
        });
        Utilities.GetControl(jqc.newTROWizardCloseBtn).on("click", function () {
            self.newTROWizard_Close();
            var data: ICAMSKey = { code: self.newTROWizardState.troCode, featureType: FeatureType.TRO };
            events.bus.publish(events.eventOpenTROEditPanel(data));
        });
    }

    public initEvents = (data: ICAMSKey): void => {
        const self = this;

        // Initialize table btns
        self.highlightsActionBtns = {
            add: { btn: $(jqc.troEditHighlightsAddBtn + ' button'), enable: false },
            edit: { btn: $(jqc.troEditHighlightsEditBtn + ' button'), enable: false },
            delete: { btn: $(jqc.troEditHighlightsDeleteBtn + ' button'), enable: false }
        };
        
        self.highlightsActionBtns.add.btn.on("click", function () {
            Utilities.GetModal(jqc.troEditModal, ModalAction.Hide);
            self.newTROWizard_Close();
            var troCode = Utilities.GetControl(jqc.troEditModal + ' [name="TROCode"]').val().toString();
            self.newTROWizard_Start(troCode, true);
        });
        self.highlightsActionBtns.edit.btn.on("click", function () {
            var table: any = Utilities.GetControl(jqc.troEditHighlightTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].TROGeomID, featureType: FeatureType.TRO };
            Utilities.GetModal(jqc.troEditModal, ModalAction.Hide);
            self.openEditGeomPanel(data, callback, rows[0].TROCode);
          
            function callback() {
                Utilities.GetModal(jqc.troEditModal, ModalAction.Show);
            }
        });
        self.highlightsActionBtns.delete.btn.on("click", function () {
            var troCode = Utilities.GetControl(jqc.troEditModal + ' [name="TROCode"]').val().toString();
            var table: any = Utilities.GetControl(jqc.troEditHighlightTable)
            let rows = table.bootstrapTable('getSelections');
            let data: ICAMSKey = { code: rows[0].TROGeomID, featureType: FeatureType.TRO };
            self.deleteTROGeom(data, false, troCode);
        });

        // Initialize table
        var table: any = Utilities.GetControl(jqc.troEditHighlightTable)
        table.bootstrapTable();

        table.on('click-row.bs.table', function (e, row, $element) {
        });
        table.on('check.bs.table', function (e, row, $element) {
            self.checkHighlightVisibleButtons();
        });
        table.on('check-all.bs.table', function (e, rowsAfter, rowsBefore) {
            self.checkHighlightVisibleButtons();
        });
        table.on('uncheck.bs.table', function (e, row, $element) {
            self.checkHighlightVisibleButtons();
        });
        table.on('uncheck-all.bs.table', function (e, rowsAfter, rowsBefore) {
            self.checkHighlightVisibleButtons();
        });
        table.on('click-cell.bs.table', function (e, field, value, row, $element) {
            if (field == "AnnotationCount") {
                Utilities.GetModal(jqc.troEditModal, ModalAction.Hide);
                events.bus.publish(events.eventZoomToWKTandHighlight([[row.WKT], true, true, FeatureType.TRO]));
            }
        });

        // Get Paths affected data
        self.GetTROGeoms(data);
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public openEditGeomPanel = (data: ICAMSKey, callback: Function = null, troCode: string = null): void => {
        const self = this;
        Utilities.BlockUI();
        Utilities.GetControl(jqc.placeholder_for_legalmodals2).load('/TRO/TROGeomEdit', { troGeomID: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();

            Utilities.GetModal(jqc.tro_GeomEditModal, ModalAction.Create);

            Utilities.GetControl(jqc.tro_GeomEditShowTROBtn).on('click', function (evt) {
                if (originalFormData != Utilities.GetControl(jqc.tro_GeomEditForm).serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) doaction();
                    });
                }
                else doaction();

                function doaction() {
                    Utilities.GetModal(jqc.tro_GeomEditModal, ModalAction.Hide);
                    var troCode = Utilities.GetControl(jqc.tro_GeomEditModal + ' [name="TROCode"]').val().toString();
                    events.bus.publish(events.eventOpenTROEditPanel({ code: troCode, featureType: FeatureType.TRO }));
                }
            });
            

            // Get form validation
            Utilities.InitFormValidation(Utilities.GetControl(jqc.tro_GeomEditModal));

            // Save the original state of the edit form
            var originalFormData = Utilities.GetControl(jqc.tro_GeomEditForm).serialize();

            // Submit
            Utilities.GetControl(jqc.tro_GeomEditSubmitBtn).on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = Utilities.GetControl(jqc.tro_GeomEditForm);
                if (form.validate().form() == false) {
                    Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_PleaseEnterAllValues" }]).then(m => {
                        if (m.success == true) toastr.error(m.data[0].value);
                        else toastr.error("Please make sure you have entered all required values.");
                    });
                    return;
                }

                Utilities.BlockUI($(jqc.tro_GeomEditModal + " .modal-content"));
                let formData = new FormData(<any>Utilities.GetControl(jqc.tro_GeomEditForm)[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/TRO/UpdateTROGeomView',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                Utilities.GetModal(jqc.tro_GeomEditModal, ModalAction.Hide);
                                events.bus.publish(events.eventRefreshMapLayer(FeatureType.TRO));

                                if (troCode != null) self.GetTROGeoms({code: troCode, featureType: FeatureType.TRO});
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_EditFailed" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });

                                //if (result.message == null) toastr.error('Failed to edit TRO!');
                                //else toastr.error(result.message)
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.UnBlockUI($(jqc.tro_GeomEditModal + " .modal-content"));
                            if (callback != null) callback();
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });

            });

            Utilities.GetControl(jqc.tro_GeomEditCloseBtn).on('click', function (evt) {
                if (originalFormData != Utilities.GetControl(jqc.tro_GeomEditForm).serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) {
                            Utilities.GetModal(jqc.tro_GeomEditModal, ModalAction.Hide);
                            if (callback != null) callback();
                        }
                    });
                }
                else {
                    Utilities.GetModal(jqc.tro_GeomEditModal, ModalAction.Hide);
                    if (callback != null) callback();
                }
            });

            Utilities.GetControl(jqc.tro_GeomEditCancelBtn).on('click', function (evt) {
                if (originalFormData != Utilities.GetControl(jqc.tro_GeomEditForm).serialize()) {
                    Utilities.CloseFormWithPrompt().then(r => {
                        if (r == true) {
                            Utilities.GetModal(jqc.tro_GeomEditModal, ModalAction.Hide);
                            if (callback != null) callback();
                        }
                    });
                }
                else {
                    Utilities.GetModal(jqc.tro_GeomEditModal, ModalAction.Hide);
                    if (callback != null) callback();
                }
            });

            Utilities.GetControl(jqc.tro_GeomEditDeleteBtn).on('click', function (evt) {
                self.deleteTROGeom(data, false, null, function (success) {
                    if (success == true) {
                        Utilities.GetModal(jqc.tro_GeomEditModal, ModalAction.Hide);
                        events.bus.publish(events.eventMapClosePopup());
                    }
                });
                
            });
        });
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetTROGeoms = (data: ICAMSKey): void => {
        const self = this;

        let url = "/TRO/GetTROGeoms";
        let query = { troCode: data.code };

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        var data = JSON.parse(result.data);
                        var table: any = Utilities.GetControl(jqc.troEditHighlightTable)
                        table.bootstrapTable('load', data);

                        self.checkHighlightVisibleButtons();
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {

                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    private CreateTROGeom = (troCode: string, wkt: string): void => {
        const self = this;

        let url = "/TRO/CreateTROGeom";
        let query = { TROCode: troCode, TROFeatureType: null, Notes: null, WKT: wkt };

        function callback() {
            Utilities.GetModal(jqc.troEditModal, ModalAction.Show);
            self.GetTROGeoms({ code: troCode, featureType: FeatureType.TRO });
        }

        $.post(url, query,
            function (result: IAPIResult) {
                try {
                    if (result.success == true) {
                        toastr.success('Created feature!')
                        events.bus.publish(events.eventRefreshMapLayer(FeatureType.TRO));
                        self.newTROWizard_Close();

                        if (self.newTROWizardState.reOpenTROEditModal == true) {
                            self.openEditGeomPanel({ code: result.data.troGeomID }, callback, troCode);
                        }
                        else {
                            self.openEditGeomPanel({ code: result.data.troGeomID }, null, troCode);
                        }  
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
                finally {
                    self.newTROWizardState = {};
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // CHECK BUTTONS
    private checkHighlightVisibleButtons = (): void => {
        const self = this;
        var table: any = Utilities.GetControl(jqc.troEditHighlightTable);
        if (table[0] == undefined) return;

        let rows = table.bootstrapTable('getSelections');

        // Reset all btns first
        Object.keys(this.highlightsActionBtns).forEach(k => {
            self.highlightsActionBtns[k].enable = false;
        });

        self.highlightsActionBtns.add.enable = true;
        // Then switch on the ones we want depending on the nde type
        if (rows && rows.length == 1) {
            self.highlightsActionBtns.edit.enable = true;
            self.highlightsActionBtns.delete.enable = true;
        }
        else if (rows && rows.length > 1) {
            //self.highlightsActionBtns.delete.enable = true;
        }

        Object.keys(this.highlightsActionBtns).forEach(k => {
            if (self.highlightsActionBtns[k].enable == true) self.highlightsActionBtns[k].btn.prop("disabled", false);
            else self.highlightsActionBtns[k].btn.prop("disabled", true);
        });
    }

    // ----------------------------------------------------------- //
    // DELETE
    public deleteTROGeom = (data: ICAMSKey, resetPanels: Boolean, refreshTROGeomTable_troCode: string, callback: Function = null): void => {
        const self = this;
        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post('/TRO/DeleteTROGeom', { troGeomID: data.code },
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            events.bus.publish(events.eventRefreshMapLayer(FeatureType.TRO));
                            if (resetPanels == true) {
                                events.bus.publish(events.eventClearAllHighlights());
                                events.bus.publish(events.eventResetAllPanels());
                                events.bus.publish(events.eventRemoveAllMapInteractions());
                                events.bus.publish(events.eventResetAllButtons(true));
                                
                            }
                            if (refreshTROGeomTable_troCode != null) {
                                self.GetTROGeoms({ code: refreshTROGeomTable_troCode, featureType: FeatureType.TRO });
                            }
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            if (callback != null) callback(true);
                        }
                        else {
                            if (result.message != null) toastr.error(result.message);
                            else toastr.error('Delete failed: the record has child records - delete these before deleting the parent record.');
                            if (callback != null) callback(false);
                        }
                    }
                    catch (err) {
                        console.log(err);
                        alert(err);
                        if (callback != null) callback(false);
                    }
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }

    // ----------------------------------------------------------- //
    // New Route WIZARD
    public newTROWizard_Start = (troCode: string, reOpenTROEditModal: Boolean): void => {
        const self = this;

        //if (self.map.getView().getZoom() < 15) {
        //    Utilities.GetTranslations([{ textPack: TextPack.OfficerMapTextPack, key: "TS_Toastr_ZoomCloserError" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
        //    return;
        //}

        self.newTROWizardState = { troCode: troCode, reOpenTROEditModal: reOpenTROEditModal };

        Utilities.GetControl(jqc.newTROWizard_SaveBtn).hide();
        Utilities.GetControl(jqc.newTROWizard_CancelBtn).hide();
        Utilities.GetControl(jqc.newTROWizardPanel).addClass('show');
        if (self.subscriptionDrawCompleted) self.subscriptionDrawCompleted();

        // Create draw interaction
        Utilities.GetControl(jqc.newTROWizard_CancelBtn).show();
        self.subscriptionDrawCompleted = events.bus.subscribe(events.eventDrawCompelted, m => {
            self.newTROWizardState.drawFeature = m.payload;
            Utilities.GetControl(jqc.newTROWizard_SaveBtn).show();
            self.subscriptionDrawCompleted();
            setTimeout(function () { events.bus.publish(events.eventRemoveAllMapInteractions()); }, 100); // Timeout to prevent a double click zoom in event
        });

        // Zoom to existing rows
        var table: any = Utilities.GetControl(jqc.troEditHighlightTable);
        if (table[0] != undefined) {
            let wkts: Array<any> = table.bootstrapTable('getData').map(m => m.WKT);
            if (wkts != null && wkts.length>0) events.bus.publish(events.eventZoomToWKTandHighlight([wkts, true, true, FeatureType.TRO]));
        }

        // Fire select event
        events.bus.publish(events.eventStartDrawSelection([GeometryType.LINE_STRING, 15, null, null, OptionalTracingLayer.routeLineLayer]));
    }

    private newTROWizard_Save = (): void => {
        const self = this;
        let format = new WKT();
        let geom = self.newTROWizardState.drawFeature.getGeometry();
        let wkt = format.writeGeometry(geom);

        this.CreateTROGeom(self.newTROWizardState.troCode, wkt);
    }

    private newTROWizard_Close = (): void => {
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true))
        if (this.subscriptionDrawCompleted) this.subscriptionDrawCompleted();
    }

    private newTROWizard_Cancel = (): void => {
        events.bus.publish(events.eventClearAllHighlights());
        events.bus.publish(events.eventResetAllPanels());
        events.bus.publish(events.eventRemoveAllMapInteractions());
        events.bus.publish(events.eventResetAllButtons(true))
        if (this.subscriptionDrawCompleted) this.subscriptionDrawCompleted();
    }

    // ----------------------------------------------------------- //
    // MISC

}




